import { ReactNode, createContext } from "react";
import useTipoServico, { TipoServicoType, CreateTipoServicoType, UpdateTipoServicoType } from "../context/hooks/useTipoServico";

interface TipoServicoContextProviderProps {
    children: ReactNode;
}

export interface TipoServicoContextData {
    getAllTipoServicoPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<TipoServicoType[] | null>;
    listTipoServicoByEmpresa: (empresaId: number) => Promise<TipoServicoType[] | null>;
    setTipoServico: any;
    tipoServico: TipoServicoType;
    setListTipoServico: any;
    listTipoServico: TipoServicoType[];
    setInitialListTipoServico: any;
    initialListTipoServico: TipoServicoType[];
    setPageCount: any;
    pageCount: number;
    createTipoServico: (createTipoServicoType: CreateTipoServicoType) => Promise<CreateTipoServicoType | null>;
    updateTipoServico: (updateUserTypeType: UpdateTipoServicoType) => Promise<UpdateTipoServicoType | null>;
    deleteTipoServico: (id: number) => Promise<TipoServicoType | null>;
}

const initialState: TipoServicoContextData = {
    getAllTipoServicoPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    listTipoServicoByEmpresa: async (empresaId: number) => Promise.resolve(null),
    setTipoServico: () => { },
    tipoServico: {
        id: 0,
        name: "",
        value: 0,
        empresaId: 0,
    },
    setListTipoServico: () => { },
    listTipoServico: [],
    setInitialListTipoServico: () => { },
    initialListTipoServico: [],
    setPageCount: () => { },
    pageCount: 0,
    createTipoServico: async (createTipoServicoType: CreateTipoServicoType) => {
        return Promise.resolve(null);
    },
    updateTipoServico: async (updateTipoServicoType: UpdateTipoServicoType) => {
        return Promise.resolve(null);
    },
    deleteTipoServico: async (id: number) => {
        return Promise.resolve(null);
    },
};

export const TipoServicoContext =
    createContext<TipoServicoContextData>(initialState);

export default function TipoServicoContextProvider({
    children,
}: TipoServicoContextProviderProps) {
    const {
        getAllTipoServicoPaged,
        listTipoServicoByEmpresa,
        createTipoServico,
        updateTipoServico,
        deleteTipoServico,
        tipoServico,
        setTipoServico,
        setListTipoServico,
        listTipoServico,
        initialListTipoServico,
        setInitialListTipoServico,
        setPageCount,
        pageCount,
    } = useTipoServico();

    return (
        <TipoServicoContext.Provider
            value={{
                getAllTipoServicoPaged,
                listTipoServicoByEmpresa,
                createTipoServico,
                updateTipoServico,
                deleteTipoServico,
                tipoServico,
                setTipoServico,
                setListTipoServico,
                listTipoServico,
                initialListTipoServico,
                setInitialListTipoServico,
                setPageCount,
                pageCount,
            }}
        >
            {children}
        </TipoServicoContext.Provider>
    );
}